import {Directive, EventEmitter, HostListener, Input, Output} from '@angular/core';

@Directive({
  selector: '[idealsClipboard], [ideals-clipboard]',
  exportAs: 'idealsClipboard',
  standalone: false,
})
export class ClipboardDirective {
  @Input('ideals-clipboard')
  public value: string;

  @Output()
  public clipboardCopy: EventEmitter<string> = new EventEmitter();

  @Output()
  public clipboardError: EventEmitter<Error> = new EventEmitter();

  @HostListener('click')
  public copyToClipboard(): void {
    this._copy(this.value)
      .then((value) => this.clipboardCopy.emit(value as string))
      .catch((e) => this.clipboardError.emit(e));
  }

  private _copy(value: string): Promise<string | Error> {
    return new Promise((resolve, reject): void => {
      if (navigator.clipboard !== undefined) {
        navigator.clipboard.writeText(value)
          .then(() => resolve(value))
          .catch(reject);
      }
    });
  }
}
